export const LOCAL_STORAGE_ACCOUNT_ID = 'currentAccountId';
export const DASHBOARD_FALLBACK_URL_NAME = 'dashboard';

// Used to determine what login mechanism a user used last.
export const AUTH_TYPE_COOKIE_NAME = 'auth_type';
